import React from 'react'
import { StyleSheet, css } from 'aphrodite'

import bgPattern from '../../assets/bgPattern.png'

import IndexAppDevelopment from './AppDevelopment/IndexAppDevelopment'
import IndexNfcAndIot from './NfcAndIot/IndexNfcAndIot'
import IndexBlockChain from './BlockChain/IndexBlockChain'

import InvertedHeader from '../Header/InvertedHeader'

export default class Portfolio extends React.Component{
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

 render(){
  return(
    <div>
    <InvertedHeader />
      <div className="ChipStuff"
          style={{
            backgroundImage: `url('${bgPattern}')`,
            height: 'inherit',
            zIndex: 313,
            width: '100vw',
            backgroundSize: 'contain',
          }}>
      	<section className={css(styles.MainDiv)}>
          <IndexAppDevelopment />
          <IndexNfcAndIot />
          <IndexBlockChain />
      	</section>
      </div>
    </div>
  );
 }
}

const styles = StyleSheet.create({
	// MainDiv : {
	// 	margin: '8em auto 0',
	// 	maxWidth: 850,
	// 	minHeight: '70vh',
	// 	'@media (max-width: 768px)' :{
 //      textAlign: 'center'
	// 	},

	// }
})


// WEBPACK FOOTER //
// ./src/Components/Portfolio/Portfolio.js